import { useToast } from "vue-toastification";
const toast = useToast();

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    toast.success("Copied to Clipboard");
  } catch (err) {
    toast.error("Failed to copy text: ", err);
    console.error("Failed to copy text: ", err);
  }
};
export const shareMessage = (message) => {
  if (navigator.share) {
    navigator.share({
        title: "Shared Message",
        text: message,
      })
      .then(() => {
        toast.success("Share was successful.");
      })
      .catch((error) => {
        console.error("Sharing failed:", error);
        toast.error("Sharing failed:", error);
      });
  } else {
    console.error("Sharing is not supported on this browser.");
    toast.error("Sharing is not supported on this browser.");
  }
};

export const formatMessage = (message) => {
  return String(message || "")
    .replace(/\n/g, "<br>")
    .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
};
 export const removeChart = (message) => {
  return String(message || "")
    .replace(/\n/g, "")  // Removes new lines
    .replace(/\*\*(.*?)\*\*/g, "$1");  // Removes ** but keeps the text inside
};

export const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
};